import { render, staticRenderFns } from "./180713.vue?vue&type=template&id=4c4ca8f3&scoped=true&"
import script from "./180713.vue?vue&type=script&lang=js&"
export * from "./180713.vue?vue&type=script&lang=js&"
import style0 from "./180713.vue?vue&type=style&index=0&id=4c4ca8f3&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c4ca8f3",
  null
  
)

export default component.exports